module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_15.5de1f57f.png";